
/**
 * @typedef {import("./Vector").default} Vector
 * @typedef {import("./Component").default} Component
 * @typedef {{ ( component: Component ) => void }} HoverEvent
 * @typedef {{ ( component: Component ) => void }} ClickEvent
 * @typedef {{ ( origin: Vector, position: Vector ) => void }} DragEvent
 */
export default class TriggerSet {

    /** @param {{ onHover: HoverEvent, onHoverOut: HoverEvent, onHoverMove: HoverEvent, onClick: ClickEvent, onDrag: DragEvent }} param0 */
    constructor({ onHover, onHoverOut, onClick, onDrag, onHoverMove }) {
        this.onHover = onHover || (() => {});
        this.onHoverOut = onHoverOut || (() => {});
        this.onHoverMove = onHoverMove || (() => {});
        this.onClick = onClick || (() => {});
        this.onDrag = onDrag || (() => {});

        this.hovering = false;
    }
}